import { FC, useContext } from "react";

import { Button } from "capitalrx-components-2.0/lib/general";
import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Semibold, Subtitle } from "capitalrx-components-2.0/lib/typography";

import { ProviderManagement } from "@/api/interfaces";
import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";
import { ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";

export interface ContactInformationViewProps {
  readonly provider: ProviderManagement.ProviderSchema;
  setIsEditContact: Function;
}

export const ContactInformationView: FC<ContactInformationViewProps> = ({ provider, setIsEditContact }) => {
  const { four } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);
  const { primary_color } = useContext(ThemeSelectorContext);

  const handleEditClick = () => {
    setIsEditContact(true);
  };

  return (
    <Stack spacing="large">
      <Shelf>
        <Subtitle>Contact Information</Subtitle>
        <Button appearance={getThemeButton("tertiary", primary_color)} icon="edit" onClick={handleEditClick}>Edit</Button>
        <Shelf.Spacer />
      </Shelf>
      <Stack>
        <Heading>Authorized Official Details</Heading>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>First Name</Semibold>
              <Body>{provider?.authorized_official_first_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Last Name</Semibold>
              <Body>{provider?.authorized_official_last_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Job Title</Semibold>
              <Body>{provider?.authorized_official_title || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Phone Number</Semibold>
              <Body>{provider?.authorized_official_phone || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Email Address</Semibold>
              <Body>{provider?.authorized_official_email || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Fax Number</Semibold>
              <Body>{provider?.authorized_official_fax || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
      </Stack>
      <Stack>
        <Heading>Primary Contact</Heading>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>First Name</Semibold>
              <Body>{provider?.primary_contact_first_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Last Name</Semibold>
              <Body>{provider?.primary_contact_last_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Job Title</Semibold>
              <Body>{provider?.primary_contact_title || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Phone Number</Semibold>
              <Body>{provider?.primary_contact_phone || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Email Address</Semibold>
              <Body>{provider?.primary_contact_email || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
      </Stack>
      <Stack>
        <Heading>Secondary Contact</Heading>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>First Name</Semibold>
              <Body>{provider?.secondary_contact_first_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Last Name</Semibold>
              <Body>{provider?.secondary_contact_last_name || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Job Title</Semibold>
              <Body>{provider?.secondary_contact_title || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
        <Grid>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Phone Number</Semibold>
              <Body>{provider?.secondary_contact_phone || "--"}</Body>
            </Stack>
          </Grid.Span>
          <Grid.Span columns={four}>
            <Stack spacing="mini">
              <Semibold>Email Address</Semibold>
              <Body>{provider?.secondary_contact_email || "--"}</Body>
            </Stack>
          </Grid.Span>
        </Grid>
      </Stack>
    </Stack>
  );
};
